/**
 * Created by zhangxixi on 2019/3/11.
 */

import Vue from 'vue';
import axios from 'axios';
import {Loading, Message} from 'element-ui';
import qs from 'qs';
import {
    getToken
} from '@/assets/js/basis'

var instance = axios.create({
    baseURL: process.env.NODE_ENV !== 'development' ? '../' : process.env.BASE_URL,
    timeout: (60000 * 30),
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }
});

/*
 * Json
 * @parame data 发送数据
 * @parame url  接口地址，去除域名、端口及项目名 必传
 * @parame method 传输类型，默认post
 * @parame loading 发送接口是否显示loging加载动画，true为显示 ，默认不显示
 * @parame ladingTxt 加载动画的文字内容
 * @parame headers 即将被发送的自定义请求头 为json对象
 * @parame responseType 服务器响应的数据类型 可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream' ，默认 json
 * @parame isNoQS 为true不用QS插件进行数据格式化
 * @parame cancelToken 取消请求的Token
 * */
const ajax = Vue.prototype.ajax = function (json) {
    json.data = json.data || {};
    json.params = json.params || {};
    json.token_key = json.token_key || false;
    return new Promise((resolve, reject) => {
        if (json.loading) {
            var timer = null;
            clearTimeout(timer);
            var loading = Loading.service({
                lock: true,
                text: json.loadingText || '',
                body: true,
                customClass: 'loading-xy'
            });
        }
        json.headers = json.headers || {};
        if (!json.token_key) {
            json.headers['Authorization'] = "Bearer " + getToken();
        }

        instance({
            method: json.method || 'post',
            url: json.url,
            data: json.isNoQS ? json.data : qs.stringify(json.data),
            params: json.isNoQS ? json.params : qs.stringify(json.params),
            headers: json.headers || null,
            cancelToken: json.token || null,
            onUploadProgress: json.onUploadProgress || null
        }).then((response) => {
            if (json.loading) {
                timer = setTimeout(function () {
                    loading.close();
                }, 300)
            }
            if (json.isDown) {
                try {
                    let blob = new Blob([JSON.stringify(response.data)]);
                    let fileName = json.fileName || decodeURI(response.headers['content-disposition'].replace('attachment; filename=', ''));
                    if ('download' in document.createElement('a')) {
                        let elink = document.createElement('a');
                        elink.download = fileName || '未命名文件';
                        elink.style.display = 'none';
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        // 释放URL 对象
                        URL.revokeObjectURL(elink.href);
                        document.body.removeChild(elink);
                    } else {
                        // IE10+下载
                        navigator.msSaveBlob(blob, fileName)
                    }
                } catch (e) {
                    if (json.DownError) {
                        Message.error('下载失败！请重试');
                    }
                }

            }
            if (!json.isNoFFur) {
                if (response.data.code !== 200) {
                    Message({
                        message: response.data.message,
                        type: 'error',
                        showClose: true,
                        duration: 3000
                    });
                }
                if(response.data.code === 401){
                    location.href = '/login';
                }
            }
            if(response.data.code == 401){
                location.href = '/login';
            }
            resolve(response.data)
        }).catch((error) => {
            if (json.loading) {
                loading.close();
            }
            if (!json.isNoFFur) {
                Message({
                    message: '服务器错误！',
                    type: 'error',
                    showClose: true,
                    duration: 3000
                });
            }
            reject(error)
        })
    })
};
const token = Vue.prototype.ajaxToken = axios.CancelToken.source;

export default {ajax, token};
